export default __webpack_public_path__ + "static/media/nbas.ee59f4fc.png";